<template>
  <div>
    <v-card class="ma-10">
      <v-card-title class="font-weight-light display-2 text-uppercase">
        All Depot Transactions
      </v-card-title>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="search"
            label="Search ..."
            class="mx-4"
            append-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-data-table
        :headers="headers"
        :items="sales"
        :items-per-page="10"
        :search="search"
        multi-sort
        class="elevation-1"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        id="sales"
      >
        <!-- maybe add expandable to hide all the info-->
        <template v-slot:body="{ items, headers }">
          <tbody>
            <tr v-for="(item, idx) in items" :key="idx">
              <td v-for="(header, key) in headers" :key="key">
                <v-text-field
                  v-if="header.type === 'text'"
                  v-model="item[header.value]"
                  label="Edit"
                  @change="save(item, 'update')"
                  single-line
                  rounded
                  :readonly="header.readonly"
                  :background-color="header.color"
                >
                </v-text-field>

                <v-btn
                  elevation="1"
                  v-if="header.type === 'btn'"
                  @click="deleteTransaction(item)"
                >
                  Delete
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>
    <div>
      <v-snackbar type="success" :value="alert" transition="fade-transition">
        Transaction updated!
      </v-snackbar>
    </div>
  </div>
</template>

<style>
#sales table thead {
  background: #e57373;
  font-size: 50px !important;
}
table.v-table thead th {
  font-size: 40px !important;

  .v-select {
    padding-left: 3px;
    background: green;
  }
}
</style>
<script>
export default {
  methods: {
    fetchAll: function () {
      this.$api
        .post(this.$store.state.pathDepth + "sessions_check.php", {})
        .then((response) => {
          this.session = response.data;
          this.$api
            .post(this.$store.state.pathDepth + "sales_query.php", this.session)
            .then((response) => {
              this.sales = response.data;
            });
        });
    },
    deleteTransaction(item) {
      console.log(item);
      var vm = this;
      this.$api
        .post(this.$store.state.pathDepth + "edit_transactions.php", item)
        .then((response) => {
          setTimeout(function () {
            console.log(response.data);
          }, 500);
          vm.alert = true;
          setTimeout(function () {
            vm.alert = false;
          }, 2000);
          this.overlay = false;
          // this.org_name = "";
          this.fetchAll();
        });
    },

    save(user, type) {
      var vm = this;

      // make sure sure we update the right org_id
      this.orgs.filter((obj) => {
        if (obj.org_name === user.org_name) {
          user.org_ID = obj.ID;
        }
      });

      // console.log(vm.info.newsletter);
      this.$api
        .post(this.$store.state.pathDepth + "orgadmin_update.php", {
          info: user,
          type: type,
          sesion: vm.session,
        })
        .then((response) => {
          setTimeout(function () {
            console.log(response.data);
          }, 500);
          vm.alert = true;
          setTimeout(function () {
            vm.alert = false;
          }, 2000);
          this.overlay = false;
          this.org_name = "";
          this.fetchOrgs();
        });
    },
    cancel() {},
    open() {},
    close() {},
  },
  created: function () {
    this.fetchAll();
  },
  watch: {},
  props: {
    query: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      search: "",
      alert: false,
      absolute: true,
      opacity: 0.7,
      overlay: false,
      org_name: "",
      sortBy: ["ID", "date_sold", "operation"],
      sortDesc: [true, true, true],
      headers: [
        {
          text: "Date",
          value: "date_sold",
          type: "text",
          readonly: false,
          color: "teal lighten-4",
        },
        {
          text: "Operation",
          value: "operation",
          type: "text",
          readonly: false,
          color: "teal lighten-4",
        },
        {
          text: "Organization",
          value: "org_name",
          type: "text",
          readonly: false,
          color: "teal lighten-4",
        },
        {
          text: "Category",
          value: "main_cat",
          type: "text",
          readonly: false,
          color: "teal lighten-4",
        },
        {
          text: "SubCategory",
          value: "sub_cat",
          type: "text",
          readonly: false,
          color: "teal lighten-4",
        },
        {
          text: "weight",
          value: "total_weight",
          type: "text",
          readonly: false,
          color: "teal lighten-4",
        },

        {
          text: "Pieces",
          value: "n_pieces_sold",
          type: "text",
          readonly: false,
          color: "teal lighten-4",
        },

        {
          text: "",
          value: "delete",
          type: "btn",
          readonly: false,
          color: "teal lighten-4",
        },
      ],
      sales: [],
      // users: [],
      // orgs: [],
    };
  },
};
</script>
